import React from "react";
import QueueAnim from 'rc-queue-anim';
import './style.less'
import {Card, Row, Col} from 'antd';

const {Meta} = Card;

export default class ParametersContent extends React.Component {

    render() {
        return (
            <div className="gimbal-description-container">
                <div className="description">
                    <div className='line'>
                        <Row>
                            <Col span="8">
                                <img src="http://qiniu.metridynamic.com/image/new-official-en/Gimbal/006.png" alt={""}/>
                                <p>8mm星光相机<br />更好的夜视能力</p>
                            </Col>
                            <Col span="8">
                                <img src="http://qiniu.metridynamic.com/image/new-official-en/Gimbal/007.png" alt={""} />
                                <p>30倍高清无损变焦<br />1080p</p>
                            </Col>
                            <Col span="8">
                                <img src="http://qiniu.metridynamic.com/image/new-official-en/Gimbal/003.png" alt={""}/>
                                <p>具有灰度和<br />彩色模式的热成像</p>
                            </Col>
                        </Row>
                    </div>
                    <div className='line'>
                        <Row>
                            <Col span="6">
                                <img src="http://qiniu.metridynamic.com/image/new-official-en/Gimbal/002.png" alt={""} />
                                <p>强大的目标跟踪能力</p>
                            </Col>
                            <Col span="6">
                                <img src="http://qiniu.metridynamic.com/image/new-official-en/Gimbal/001.png" alt={""} />
                                <p>高精度测距</p>
                            </Col>
                            <Col span="6">
                                <img src="http://qiniu.metridynamic.com/image/new-official-en/Gimbal/004.png" alt={""}/>
                                <p>三轴增稳</p>
                            </Col>
                            <Col span="6">
                                <img src="http://qiniu.metridynamic.com/image/new-official-en/Gimbal/005.png" alt={""} />
                                <p>自动跟踪和监视目标</p>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>

        )

    }
}
